<template>
  <div class="fm-grid">
    <slot :rows="rows" :loading="loading"></slot>
    <div class="third-page" v-if="showPage">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        background
        :page-sizes="[10, 20, 30, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { cloneDeep } from "lodash";
import request from "@/utils/request";
export default {
  name: "FmGrid",
  props: {
    showPage: {
      type: Boolean,
      default: true
    },
    url: {
      type: String
    },
    method: {
      type: String,
      default: "post"
    },
    mapValue: {
      type: Object,
      default: () => {
        return {
          data: "data",
          total: "total"
        }
      }
    },
    dataType: {
      type: String,
      default: 'data'
    }
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: 40,
      total: 0,
      loading: false,
      rows: [],
      params: {}
    };
  },
  created() {
    this.loading = true
    if (this.$store.state.common.nowSearchParamsPageSize ) {
      this.pageSize = this.$store.state.common.nowSearchParamsPageSize
    }
    if (this.$store.state.common.nowSearchParamsPageIndex ) {
      this.pageIndex = this.$store.state.common.nowSearchParamsPageIndex
    }
  },
  mounted() {
    if (!this.showPage) {
      this.pageSize = 99999
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  },
  methods: {
    search({ pageIndex, pageSize, params } = {}) {
      if (this.method === "get") {
        this.dataType = "params";
      }
      const url = this.url;
      const method = this.method;
      pageIndex || (pageIndex = this.pageIndex);
      pageSize || (pageSize = this.pageSize);
      this.pageIndex = pageIndex;
      this.pageSize = pageSize;
      if (!url) {
        throw new Error("请求接口名称不能不为空");
      }
      if (pageIndex <= 0) {
        pageIndex = 1;
      }
      // if (pageSize < 1 || pageSize > 200) {
      if (pageSize < 1) {
        pageSize = 10;
      }
      params?this.params = params:this.params = {}
      let combineParams = {
        ...this.params,
        pageIndex,
        pageSize,
        tenantId: this.userInfo.tenant_id,
      ...cloneDeep(params)
      };
      for (let i in combineParams) {
        if (!combineParams[i] && combineParams[i] !== 0) delete combineParams[i];
      }
      this.loading = true
      const cpt = () => {
        setTimeout(() => {
          this.loading = false;
        }, 500);
      };
      console.log('combineParams', combineParams)
      request({
        url,
        method,
        [this.dataType]: {
          ...combineParams
        }
      })
        .then(res => {
          const {
            data: { result, status: dataStatus, msg },
            status
          } = res;
          if (status !== 200) {
            return
          }
          if(dataStatus === 1002) {
            if(msg === '权限不足')return this.$message.error('权限不足')
          }
          // let { data, total } = result;
          let data = []
          let total = 0
          if (JSON.stringify(this.mapValue) === '{}') {
            data = result
          } else {
            data = result[this.mapValue.data]
            total = result[this.mapValue.total]
          }
          // console.log('结果', result)
          if (dataStatus === 1004) {
            data = [];
            total = 0;
          }
          data && (this.rows = data);
          (total || total === 0) && (this.total = total);
          let obj = {
            data: this.rows,
            page: this.pageIndex
          }
          this.$emit('getGridRes', obj)
          cpt();
        })
        .catch(error => {
          this.rows = [];
          this.total = 0;
          let obj = {
            data: this.rows,
            page: this.pageIndex
          }
          this.$emit('getGridRes', obj)
          cpt();
          throw new Error(error);
        });
    },
    handleSizeChange(pageSize) {
      this.pageIndex = 1
      const params = {
        ...this.params
      }
      // debugger
      this.$store.commit('SET_nowSearchParamsPageSize',pageSize)
      this.$store.commit('SET_SearchParamsPageIndex',1)
      this.search({ pageSize, params, pageIndex: 1});
    },
    handleCurrentChange(pageIndex) {
      const params = {
        ...this.params,
      }
      this.$store.commit('SET_SearchParamsPageIndex',pageIndex)
      this.search({ pageIndex, params });
    }
  }
};
</script>

<style lang='scss'>
</style>
